module.exports = __webpack_public_path__ + "static/media/website-setp-img-2.aee642b1.png";